export const messages = {
  en: {
    enterCommunity: {
      title: 'My Community',
      addBtn: 'Enter Community',
      province: 'Province',
      city: 'City',
      district: 'District',
      name: 'Community Name',
      code: 'Community Code',
      contact: 'Contact',
      area: 'Area',
      status: 'Status',
      operation: 'Operation',
      applyEnter: 'Apply to Enter',
      applyExit: 'Apply to Exit',
      modifyArea: 'Modify Area',
      confirmExitTitle: 'Please confirm your operation!',
      confirmExitContent: 'Confirm to exit the community, this operation cannot be undone!',
      modifyAreaTitle: 'Modify Area',
      areaPlaceholder: 'Required, please enter community area',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      statusPending: 'Pending',
      statusFailed: 'Failed',
      statusSuccess: 'Success',
      statusUnknown: 'Unknown'
    }
  },
  zh: {
    enterCommunity: {
      title: '我的小区',
      addBtn: '入驻小区',
      province: '省份',
      city: '市/州',
      district: '县/区',
      name: '小区名称',
      code: '小区编码',
      contact: '联系方式',
      area: '面积',
      status: '状态',
      operation: '操作',
      applyEnter: '申请入驻',
      applyExit: '申请退出',
      modifyArea: '修改面积',
      confirmExitTitle: '请确认您的操作!',
      confirmExitContent: '确认退出小区，退出后不可恢复!',
      modifyAreaTitle: '修改面积',
      areaPlaceholder: '必填，请填写小区面积',
      cancel: '取消',
      confirm: '确认',
      save: '保存',
      statusPending: '入驻审核',
      statusFailed: '入驻失败',
      statusSuccess: '入驻成功',
      statusUnknown: '未知'
    }
  }
}